// extracted by mini-css-extract-plugin
export default {"card":"E0-z","carouselContainer":"F0-z","carouselContent":"G0-z"};